import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=d5a129ea"
import script from "./WorkPlace.vue?vue&type=script&lang=js"
export * from "./WorkPlace.vue?vue&type=script&lang=js"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=d5a129ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports